// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-7467cdeb]{outline:2px dashed grey;outline-offset:-10px;padding:30px 10px;min-height:200px;position:relative;border-radius:4px}", ""]);
// Exports
module.exports = exports;
